export default "__VITE_ASSET__945c04cd__"